import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

interface Conv {
  id: number;
  other_user: { id: number; name: string; avatar: string | null; is_verified: boolean };
  ad: { id: number; title: string; price: string } | null;
  last_message: string | null;
  last_message_at: string | null;
  unread_count: number;
  is_buyer: boolean;
}

const ConversationsPage: React.FC = () => {
  const [convs, setConvs] = useState<Conv[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const hasToken = Boolean(localStorage.getItem('user'));

  useEffect(() => {
    if (!hasToken) { navigate('/login'); return; }
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await api.get('/conversations');
        const d = res.data.data?.data || res.data.data || [];
        setConvs(Array.isArray(d) ? d : []);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    fetch();
  }, [hasToken, navigate]);

  const ago = (d: string | null) => {
    if (!d) return '';
    const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
    if (s < 60) return '\u0627\u0644\u0622\u0646';
    if (s < 3600) return Math.floor(s/60) + ' \u062f';
    if (s < 86400) return Math.floor(s/3600) + ' \u0633';
    if (s < 2592000) return Math.floor(s/86400) + ' \u064a\u0648\u0645';
    return Math.floor(s/2592000) + ' \u0634\u0647\u0631';
  };

  if (loading) return (
    <div style={{padding:'60px 16px',textAlign:'center',fontFamily:"'Cairo',sans-serif"}}>
      <p style={{color:'#9E9E9E',fontSize:14}}>{'\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644...'}</p>
    </div>
  );

  return (
    <div style={{fontFamily:"'Cairo',sans-serif"}}>
      <h1 style={{fontSize:22,fontWeight:700,color:'#212121',margin:'0 0 20px'}}>{'\ud83d\udcac \u0627\u0644\u0645\u062d\u0627\u062f\u062b\u0627\u062a'}</h1>

      {convs.length === 0 ? (
        <div style={{background:'#fff',borderRadius:12,border:'1px solid #E0E0E0',padding:'60px 20px',textAlign:'center'}}>
          <span style={{fontSize:48}}>{'\ud83d\udcac'}</span>
          <p style={{color:'#9E9E9E',fontSize:15,marginTop:12}}>{'\u0644\u0627 \u062a\u0648\u062c\u062f \u0645\u062d\u0627\u062f\u062b\u0627\u062a'}</p>
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:4}}>
          {convs.map(c => (
            <Link key={c.id} to={'/my/conversations/' + c.id} style={{
              display:'flex',gap:12,alignItems:'center',padding:'14px 16px',
              background: c.unread_count > 0 ? '#E6F2F0' : '#fff',
              borderRadius:12,border:'1px solid ' + (c.unread_count > 0 ? '#BFDEDA' : '#E0E0E0'),
              textDecoration:'none',color:'inherit',transition:'all 0.2s',
            }}>
              <div style={{width:50,height:50,borderRadius:'50%',background:'#005343',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,fontWeight:700,color:'#fff',overflow:'hidden',flexShrink:0}}>
                {c.other_user?.avatar ? <img src={c.other_user.avatar} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} /> : (c.other_user?.name?.charAt(0) || '?')}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
                  <div style={{display:'flex',alignItems:'center',gap:6}}>
                    <span style={{fontSize:14,fontWeight:c.unread_count>0?700:600,color:'#212121'}}>{c.other_user?.name}</span>
                    {c.other_user?.is_verified && <span style={{fontSize:11,color:'#2196F3'}}>✓</span>}
                  </div>
                  <span style={{fontSize:11,color:'#BDBDBD'}}>{ago(c.last_message_at)}</span>
                </div>
                {c.ad && <p style={{fontSize:11,color:'#005343',margin:'0 0 2px'}}>{c.ad.title}</p>}
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <p style={{fontSize:13,color:c.unread_count>0?'#424242':'#9E9E9E',margin:0,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth:'80%',fontWeight:c.unread_count>0?600:400}}>
                    {c.last_message || '\u0644\u0627 \u062a\u0648\u062c\u062f \u0631\u0633\u0627\u0626\u0644'}
                  </p>
                  {c.unread_count > 0 && <span style={{background:'#005343',color:'#fff',fontSize:11,fontWeight:700,padding:'2px 8px',borderRadius:12,minWidth:20,textAlign:'center'}}>{c.unread_count}</span>}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConversationsPage;
